import { getIn } from '@/imports-files/common/common';

export function InputError(formik, fieldName) {

  if (((getIn(formik.errors, fieldName) && getIn(formik.touched, fieldName)) ||
    getIn(formik.status, fieldName) && getIn(formik.touched, fieldName))) {
    return {
      border: '1px solid var(--default-error-color)',
      boxShadow: 'none'
    }
  }

}
